import { useEffect } from 'react';
import {
    ProductReviewsContainer, ProductReviewsTitle, PreviousPage,
    HistoryRoutes, HistoryRoute
} from './styled';
import { useParams, useNavigate } from 'react-router-dom';

import rightArrow from 'assets/icons/black-right-arrow.svg'
import backArrow from 'assets/icons/black-back-arrow.svg'
import productMock from 'assets/images/mock-product.png';

import ProductDetail from './ProductDetail';
import Subscribe from 'components/Subscribe';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { getProductByIdFetch } from 'store/states'
import { Helmet } from "react-helmet-async";
import { AxiosError } from 'axios';

function ProductReviews() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { labelId } = useParams();
    const { isLoading, productById, error } = useSelector((state: RootState) => state.products);

    useEffect(() => {
        dispatch(getProductByIdFetch(labelId))
    }, [dispatch, labelId])

    useEffect(() => {
        if (error && (error as AxiosError).status === 404) {
            navigate('/page-not-found')
        }
    }, [error, navigate])

    const isObjectEmpty = Object.keys(productById).length

    return (
        <ProductReviewsContainer className='container'>
            <Helmet>
                <title>{productById?.brand + ' ' + productById?.model}</title>
                <meta name="description" content={productById?.paragraphs && productById?.paragraphs[0]?.text} />

                <meta name="og:title" content={productById?.brand + ' ' + productById?.model} />
                <meta name="og:description" content={productById?.paragraphs && productById?.paragraphs[0]?.text} />
                <meta name="og:image" content={productById?.image && productById?.image.length ? productById?.image[0]?.image : productMock} />
            </Helmet>
            <PreviousPage onClick={() => navigate(-1)}>
                Back to Product Reviews page
                <img src={backArrow} alt='back-arrow' />
            </PreviousPage>
            <ProductReviewsTitle>Product Reviews</ProductReviewsTitle>
            <HistoryRoutes>
                <HistoryRoute>
                    Product Reviews
                    <img src={rightArrow} alt='right-arrow' />
                </HistoryRoute>
                {isObjectEmpty && productById?.tags[0]?.tag ? (
                    <HistoryRoute>
                        {productById.tags[0].tag}
                        <img src={rightArrow} alt='right-arrow' />
                    </HistoryRoute>
                ) : null}
                {isObjectEmpty && productById?.brand ? (
                    <HistoryRoute>
                        {productById.brand}
                        <img src={rightArrow} alt='right-arrow' />
                    </HistoryRoute>
                ) : null}
                {isObjectEmpty && productById?.model ? (
                    <HistoryRoute>{productById?.model}</HistoryRoute>
                ) : null}
            </HistoryRoutes>
            {isLoading ? 'Loading...' : (
                isObjectEmpty ?
                    <ProductDetail
                        {...productById}
                        key={productById?.id}
                        images={productById?.image}
                        author={productById?.author}
                        createdAt={productById?.created_at}
                        price={productById?.retail_price}
                        csavPrice={productById?.csav_price}
                        csavUrl={productById?.csav_url}
                    />
                    : null
            )}

            <Subscribe
                title="Subscribe to get updates on the new products"
                isFooter={false}
            />
        </ProductReviewsContainer>
    );
}

export default ProductReviews;
